import { SquareArrowOutUpRight } from 'lucide-react';
import styled from 'styled-components';

import Button from '@/components/Button/Button';
import Tooltip from '@/components/Tooltip/TooltipV2';
import Typo from '@/components/Typography/Typo';
import { useFeedbackSourceInfo } from '@/hooks/domain/useFeedbackSourceInfo';
import { getSourceIcon } from '@/types/feedbackConst';

const SourcePropertyValue = (props: FeedbackSourceT) => {
  const { displayText } = useFeedbackSourceInfo({
    channel: props.channel,
    domain: props.domain,
    type: props.type,
  });

  const SourceIcon = getSourceIcon(props.type);

  return (
    <div className="flex items-center gap-1 truncate">
      {SourceIcon}
      <Tooltip tooltipNode={displayText}>
        <SourceText type="body3">{displayText}</SourceText>
      </Tooltip>
      {props.link && (
        <Button variant="secondary" style={{ height: 20, width: 20 }}>
          <SquareArrowOutUpRight
            size={12}
            className="text-gray-600"
            onClick={() => {
              window.open(props.link, '_blank');
            }}
          />
        </Button>
      )}
    </div>
  );
};

export const SourceText = styled(Typo)`
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export default SourcePropertyValue;
